import * as _ from "lodash";
import React, { useCallback, useId, useMemo } from "react";
import { useMarketAreaStore, userStore } from "../../../Store/userStore";
import { MarketAreaSettings } from "../../../Models/ApplicationModels";

const defaultOptions: any = [
    {
        key: "all_admin",
        value: `All market areas (Admin)`,
    },
    {
        key: "all_user",
        value: `All market areas (User)`,
    },
];
type Option = { key: string; value: string };
export default function MarketAreaSwitcher() {
    const user = userStore((s) => s.user);
    const setMarketAreaSettings = useMarketAreaStore(
        (s) => s.setMarketAreaSettings
    );

    const activeMarketArea = useMarketAreaStore(
        (s) => s.marketAreaSettings.activeMarketArea
    );
    const userMode = useMarketAreaStore((s) => s.marketAreaSettings.userMode);

    const marketAreaOptions: Option[] = useMemo(() => {
        const items = (user?.marketAreas ?? [])
            .filter(
                (m): m is string => typeof m === "string" && m.trim().length > 0
            )
            .flatMap((m) => [
                { key: `${m}_admin`, value: `${m} (Admin)` },
                { key: `${m}_user`, value: `${m} (User)` },
            ])
            .sort((a, b) => a.key.localeCompare(b.key)); // sort ascending by key

        return defaultOptions.concat(items);
    }, [user?.marketAreas]);

    const marketAreaValue: string = `${activeMarketArea}_${
        userMode ? "user" : "admin"
    }`;

    const handleMarketAreaChange = useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>) => {
            const [area, mode] = e.target.value.split("_");
            const payload: MarketAreaSettings = {
                activeMarketArea: area,
                userMode: mode === "user",
            };
            setMarketAreaSettings(payload);
            window.location.href = "/";
        },
        [setMarketAreaSettings]
    );

    const selectId = useId();

    return (
        <div className="MarketAreaSwitcher">
            <div>
                <div className="form-group">
                    <label htmlFor={selectId}>Change market area</label>
                    <select
                        value={marketAreaValue}
                        id={selectId}
                        onChange={handleMarketAreaChange}
                        className="form-control me-3"
                    >
                        {marketAreaOptions.map((opt) => (
                            <option key={opt.key} value={opt.key}>
                                {opt.value}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
}
